import { colors } from "../colors";

export const buttonStyles = `
  padding: .5rem 4rem;
  border: 2px solid ${colors.accentOrange.getHex()};
  background: ${colors.accentOrange.getHex()};
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  transform: scale(1);
  transition: all .3s ease;
  text-family: Rajdhani;
  font-weight: 300;
  text-align: center;
  :hover {
    transform: scale(1.1);
    transition: all .3s ease;
    background: white;
    color: ${colors.accentOrange.getHex()};
    border: 2px solid ${colors.accentOrange.getHex()};
  }
  :active, :focus {
    border: 2px solid ${colors.accentOrange.getHex()};
    background: none;
    transition: all .3s ease;
  }
`;
